/**
 * Etapas del ciclo de vida del claim (las del board de Claims de Proactive), en
 * el orden en que camina un claim. Es la lista del dropdown de "claim status" y
 * la que usa la barra de status. Al cambiarlas, el routing mueve el claim al
 * departamento dueño de la etapa (ver backend lifecycleRouting).
 */
export const LIFECYCLE: string[] = [
  'Lead', 'Contract Sent', 'Contract Signed', 'Waiting Documents', 'HOLD',
  'Claim Review', 'Claim Accepted', 'Claim Not Accepted', 'Denied',
  'Claim in', 'Insurance inspection', 'Re-inspection request/ed', 'Waiting approval',
  'Approved', 'Approved for Repairs', 'Supplementing', 'Supplement Resolved',
  'ATR request', 'Review ATR', 'ATR Sent', 'ATR Follow up', 'ATR Rejected',
  'Waiting /Completion', 'Settlement Process', 'Project Completed', 'Finalized',
  'Claim CANCELLED',
];

/**
 * Clave del grupo de los claims que no tienen etapa. Es una CLAVE interna (la misma en todas
 * las vistas para que un claim caiga siempre en el mismo grupo), no el texto que se muestra:
 * la etiqueta va por i18n donde se pinta.
 */
export const SIN_ETAPA = 'Sin etapa';

/** Paleta del puntito de cada grupo (como los grupos de colores de Monday). */
const COLORES_GRUPO = ['#2f5fb0', '#c0453f', '#2c8a52', '#9a7a1e', '#6b46c1', '#2a8f86', '#c2683a', '#0d9488', '#b45309', '#be185d'];

/** Color ESTABLE por etapa: la misma etapa se ve del mismo color en Claims y en el Finder. */
export function colorDeGrupo(etapa: string): string {
  return COLORES_GRUPO[[...etapa].reduce((a, ch) => a + ch.charCodeAt(0), 0) % COLORES_GRUPO.length];
}

/**
 * Agrupa filas por etapa en el ORDEN del ciclo de vida — los grupos del board, no un montón de
 * filas sueltas. Las etapas que NO están en LIFECYCLE (labels históricos de Monday, status de
 * Payments) y "Sin etapa" van al final, en el orden en que aparecen. `orden` (opcional) ordena
 * las filas DENTRO de cada grupo.
 *
 * Fuente ÚNICA del agrupado: si mañana cambia el orden de las etapas, cambia en las dos vistas
 * a la vez (Claims y Finder) y no se abre la brecha de siempre entre dos pantallas.
 */
export function agruparPorEtapa<T>(
  filas: T[],
  etapaDe: (f: T) => string,
  orden?: (a: T, b: T) => number,
): Array<{ stage: string; rows: T[] }> {
  const porEtapa = new Map<string, T[]>();
  for (const f of filas) {
    const s = etapaDe(f);
    (porEtapa.get(s) ?? porEtapa.set(s, []).get(s)!).push(f);
  }
  const ordenar = (rows: T[]) => (orden ? [...rows].sort(orden) : rows);
  const out: Array<{ stage: string; rows: T[] }> = [];
  for (const stage of LIFECYCLE) {
    const rows = porEtapa.get(stage);
    if (rows) { out.push({ stage, rows: ordenar(rows) }); porEtapa.delete(stage); }
  }
  for (const [stage, rows] of porEtapa) out.push({ stage, rows: ordenar(rows) });
  return out;
}
